module.exports = __webpack_public_path__ + "img/pink-home.59040283.png";